exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.vue-ellipse-risco-container {\n  text-align: center; margin: 35px 50px 0 0;\n}\ndiv.ellipse-progress-info-risco {\n  position: relative;\n  top: -28px;\n}\ndiv.ellipse-progress-info-risco > span:first-child {\n  color: #888888;\n  font-size: 40px;\n  font-weight: bold;\n  display: block;\n  line-height: 40px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #E6E9F0;\n}\ndiv.ellipse-progress-info-risco > span:last-child {\n  color: #79889F;\n}\ndiv.tag-legenda-risco {\n  position: relative;\n  top: -80px;\n}\n.personal-infos .tab-content { padding: 0 !important;\n}\n", ""]);

// exports
